import React from 'react';

import { Textbox } from './Textbox';
import { omit } from 'lodash';

export interface IMDFTextboxProps {
  autoComplete?: string;
  autoFocus?: boolean | 'selectAll';
  className?: string;
  defaultValue?: string;
  disabled?: boolean;
  maxLength?: number;
  minLength?: number;
  name?: string;
  placeholder?: string;
  readOnly?: boolean;
  // ref?: any; // Placeholder for React 19 forwarded references
  required?: boolean;
  title?: string;
  type?: string;
  value?: string;
  onBlur?: () => void;
  onChange?: (value: string) => void;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  onFocus?: () => void;
  onKeyUp?: (evt: any) => void;
  [x: string]: any;
}

export class MDFTextbox extends React.Component<IMDFTextboxProps, any> {
  public textBox: Textbox;

  private setTextBox = (textBox: Textbox) => {
    this.textBox = textBox;
  };

  static displayName = 'MDFTextbox';

  // The code that used to be here was moved to the Textbox class, so this becomes just a pass-through for backward compatibility.
  render() {
    const props = omit(this.props, 'usePopover', 'helpMessage', 'labelText');
    return <Textbox {...props} ref={this.setTextBox}/>;
  }
}
